import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import SvgLogo from '@public/assets/logo-black.svg';
import { Typography } from 'antd';
import styled from 'styled-components';

import { clientConfig } from '@/config/clientConfig';
import { Button } from '@/shared/components';
import { useAppLogout } from '@/shared/hooks/useAppLogout';
import { PageDialog } from '@/shared/layouts/PageDialog';
import { Icon } from '@/shared/uikit/Icon';
import { Title } from '@/shared/uikit/Title';

import { SubscriptionNotActiveVariant } from './useSubscriptionStore';

export const SubscriptionLockScreen: FC<{ variant: SubscriptionNotActiveVariant }> = ({
  variant,
}) => {
  const { t } = useTranslation('common');
  const { appLogout } = useAppLogout();

  return (
    <PageDialog>
      <Container>
        <Image src={SvgLogo} alt="logo" width={76} height={48} />
        <TextWrapper>
          <Title style={{ fontSize: 24 }}>{t(`subscriptionLockScreen.${variant}.title`)}</Title>
          <Typography style={{ fontSize: 18 }}>
            {t(`subscriptionLockScreen.${variant}.description`)}
          </Typography>
        </TextWrapper>

        <StyledLink href={`${clientConfig.personalAccount.origin}/en/profile`}>
          <Button
            style={{ color: 'white' }}
            text={t(`subscriptionLockScreen.${variant}.buttonTitle`)}
            iconPosition="end"
            icon={<Icon name="ArrowRight" />}
          />
        </StyledLink>
        <Typography.Link underline onClick={appLogout}>
          {t('logout')}
        </Typography.Link>
      </Container>
    </PageDialog>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 24px;
  width: min(548px, calc(100% - 16px));
  min-height: 258px;
  gap: 24px;

  background: white;
  border-radius: 12px;

  position: relative;
  overflow: hidden;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 8px;
`;

const StyledLink = styled(Link)`
  width: 100%;
`;
